<script setup lang='ts'>
import type { SEX } from '~/shared/constants'

const props = withDefaults(defineProps<{
  name?: string
  sex?: typeof SEX[number]['value']
}>(), {
  name: '',
  sex: 1,
})
</script>

<template>
  <div class="flex items-center w-100% line-1">
    <span>{{ props.name.slice(0, 1) }}</span>
    <!-- <span class="mosaic">{{ props.name.slice(1) }}</span> -->
    <span>{{ Number(props.sex) === 2 ? '女士' : '先生' }}</span>
  </div>
</template>

<style lang='scss' scoped>
.mosaic {
  color: transparent;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  -webkit-appearance: none;
  user-select: none;
}
</style>
